import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { REFRESH_TOKEN_API_URL } from "../action/apiPath";
import { Cookie } from "../util/cookie";
import axios from "axios";

const ProtectedRoute = ({ children }) => {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isLoading, setIsLoading] = useState(true); // Add a loading state

    const getAcceesToken = async () => {
        const refreshToken = Cookie.getCookie("refreshToken");
        if (!refreshToken) {
            setIsLoading(false);
            return;
        }

        try {
            const response = await axios.post(REFRESH_TOKEN_API_URL, {
                refresh_token: refreshToken
            }, {
                'Content-Type': "application/json"
            });

            if (response?.data?.data?.access_token) {
                setIsLoggedIn(true);
                localStorage.setItem("accessToken", response?.data?.data?.access_token);
            }

        } catch (e) {
            
        }

        setIsLoading(false);
    }

    useEffect(() => {
        if (pathname.startsWith("/admin/") && localStorage.getItem("role") != "admin") {
            navigate("/");
        }
        if (!pathname.startsWith("/admin/") && localStorage.getItem("role") == "admin") {
            navigate("/admin/prompts");
        }
    }, [pathname]);

    useEffect(() => {
        const isTokenAvailable = localStorage.getItem('accessToken');
        if (isTokenAvailable) {
            setIsLoggedIn(true);
            setIsLoading(false);
        } else {
            getAcceesToken();
        }

        const interval = setInterval(() => {
            if (!localStorage.getItem('accessToken')) {
                navigate("/login");
            }
        }, 2000);

        return () => clearInterval(interval);
    }, []);

    if (isLoading) {
        return <div>Loading...</div>; // Show a loading indicator while checking
    }

    return isLoggedIn || isLoading ? (
        <>{children}</>
    ) : (
        <Navigate to="/login" replace />
    );
};

export default ProtectedRoute;
